module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_SpareB_2.5f98c16d.jpg";